/* eslint-disable react-hooks/exhaustive-deps */
import { addWeeks, differenceInWeeks, format, parseISO } from "date-fns";
import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
// import fileicon from "../../Assets/Img/fileicon.svg";
import { Card, CardContent, Chip, StepConnector, Tooltip } from "@mui/material";
import Box from "@mui/material/Box";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";
import { styled } from "@mui/system";
import { Editor } from "@tinymce/tinymce-react";
import fileicon from "../../Assets/Img/fileicon-cc.svg";
import instadeliverables from "../../Assets/Img/insta deliverables.svg";
import youtubedeliverables from "../../Assets/Img/youtube deliverables.svg";
import customCampainGif from "../../Assets/Img/customCampainGif.gif";
import { DropDown } from "../../Common/Components/DropDown";
import { InputLabel } from "../../Common/Components/InputLabel";
import axiosMain from "../../http/axiosMain";
import "./Campaign.css";
import statesData from "./statesData";
import CheckIcon from "@mui/icons-material/Check";

const genderOptions = [
  {
    label: "Select All",
    value: "all",
  },
  {
    label: "Male",
    value: "male",
  },
  {
    label: "Female",
    value: "female",
  },
  {
    label: "Other",
    value: "other",
  },
];
const steps = ["Campaign Details", "Audience", "Deliverables", "Overview"];

export default function CampaignForm() {
  const [activeWeek, setActiveWeek] = useState(0);
  const [minBudget, setMinBudget] = useState(3000); // changed from 5000 to 0
  const [maxBudget, setMaxBudget] = useState(5000000); // changed from 1000000000 to 50 lakhs (5 million)
  const [localLaunchDate, setLocalLaunchDate] = useState("");

  const [currentStep, setCurrentStep] = useState(1);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [file, setFile] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedAge, setSelectedAge] = useState([]);
  const [timeLine, setTimeLine] = useState([]);
  const [selectedCity, setSelectedCity] = useState([]); // Holds the selected city

  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedState, setSelectedState] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(""); // Track which modal is open
  const [languages, setLanguages] = useState([]);
  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const [selectedGenders, setSelectedGenders] = useState([]);

  const [CampaignFormCreatee, setCampaignFormCreatee] = useState({
    product_name: "",
    launch_date: "",
    campaign_primary_objective: "",
    campaign_secondary_objective: "",
    campaign_title: "",
    description: "",
    compensation_type: "",
    budget: "",
    gender: "",
    language: "",
  });
  // Helper function to format numbers
  const formatNumber = (num) => {
    if (num >= 10000000) return `${(num / 10000000).toFixed(1)} Cr`;
    if (num >= 100000) return `${(num / 100000).toFixed(1)} L`;
    if (num >= 1000) return `${(num / 1000).toFixed(0)}k`;
    return num;
  };

  const [activeField, setActiveField] = useState("");

  const handleChangee = (e) => {
    const { name, value } = e.target;
    setCampaignFormCreate((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleFocus = (fieldName) => {
    setActiveField(fieldName);
  };

  const handleBlur = () => {
    setActiveField("");
  };

  const getFieldClass = (fieldName) =>
    activeField === fieldName ? "form-control active-field" : "form-control";

  const handleConfirm = async (e) => {
    setShowModal(false);

    if (modalType === "publish" && typeof handleSubmit === "function") {
      const success = await handleSubmit(e);
      if (success) {
        navigate("/campaign");
      }
    } else if (modalType === "draft" && typeof handleSaveDraft === "function") {
      const success = await handleSaveDraft(e);
      if (success) {
        navigate("/campaign");
      }
    }
  };

  const openModal = (type) => {
    setModalType(type);
    setShowModal(true);
  };

  const [CampaignFormCreate, setCampaignFormCreate] = useState({
    campaign_title: "",
    campaign_obj: "",
    description: "",
    compensation_type: "",
    budget: minBudget || "",
    file: "",
    state: [],
    city: [],
    gender: [],
    language: [],
    age_group: [],
    timeline: [],
    launch_date: "",
    flag_update: false,
    product_name: "",
    campaign_primary_objective: "",
    campaign_secondary_objective: "",
  });
  const resetForm = () => {
    setCampaignFormCreate({
      campaign_title: "",
      campaign_obj: "",
      description: "",
      compensation_type: "",
      budget: minBudget || "",
      file: "",
      state: [],
      city: [],
      gender: [],
      language: [],
      age_group: [],
      timeline: [],
      launch_date: "",
      flag_update: false,
      product_name: "",
      campaign_primary_objective: "",
      campaign_secondary_objective: "",
    });
  };

  const [selectedFilteName, setSelectedFilteName] = useState("");

  // Handle file selection
  const handleFileSelect = async (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const reader = new FileReader();

      reader.onload = async (event) => {
        const arrayBuffer = event.target.result;
        const buffer = new Uint8Array(arrayBuffer);

        // Convert to base64 for preview
        const imageUrl = URL.createObjectURL(selectedFile);

        // Update states
        setSelectedImage(imageUrl); // Show Image Preview
        setSelectedFilteName(selectedFile.name);

        // File Data for Backend
        const fileData = {
          fieldname: "file",
          originalname: selectedFile.name,
          encoding: "7bit",
          mimetype: selectedFile.type,
          buffer: buffer,
          size: selectedFile.size,
        };

        setFile(fileData);
        setCampaignFormCreate({ ...CampaignFormCreate, file: fileData });
      };

      reader.readAsArrayBuffer(selectedFile); // Read as binary data
    }
  };

  // Handle drag and drop
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const droppedFile = e.dataTransfer.files[0];
    if (droppedFile) {
      setFile(droppedFile);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "state") {
      setSelectedState(value); // Update selected state
      const stateObj = statesData?.find((state) => state.iso2 === value);
      setCities(stateObj ? stateObj.cities : []);

      // Update both state and reset city
      setCampaignFormCreate((prev) => ({
        ...prev,
        [name]: value,
        city: "", // Reset city when state changes
      }));
    } else {
      // For all other fields including date
      setCampaignFormCreate((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  // // Handle form input changes
  // const handleChange = (e) => {
  //   const { name, value } = e.target;

  //   setCampaignFormCreate({
  //     ...CampaignFormCreate,
  //     [name]: value,
  //   });
  // };

  const [contentTypes, setContentTypes] = useState([
    {
      platform: "Instagram",
      items: [
        { id: "reels", label: "Reels", count: 1, checked: false },
        { id: "posts", label: "Posts", count: 1, checked: false },
        { id: "story", label: "Story", count: 1, checked: false },
      ],
    },
    {
      platform: "YouTube",
      items: [
        { id: "shorts", label: "Shorts", count: 1, checked: false },
        { id: "video", label: "Video", count: 1, checked: false },
        { id: "liveStream", label: "Live Stream", count: 1, checked: false },
      ],
    },
  ]);

  const handleNextbtn = () => {
    if (currentStep < totalSteps) {
      setCurrentStep((prevStep) => prevStep + 1);
    }
  };

  const handlePrevbtn = () => {
    if (currentStep > 1) {
      setCurrentStep((prevStep) => prevStep - 1);
    }
  };

  const totalSteps = 4;

  const handleNext = () => {
    setCurrentStep((prev) => Math.min(prev + 1, totalSteps));
  };

  const handlePrev = () => {
    setCurrentStep((prev) => Math.max(prev - 1, 1));
  };

  const ageGroups = [
    "+ 0-18",
    "+ 18-21",
    "+ 21-24",
    "+ 24-27",
    "+ 27-30",
    "+ 30-35",
    "+ 35-45",
    "+ 45 & Above",
  ];
  useEffect(() => {
    // All state and city data
    const allStateCodes = statesData.map((state) => state.iso2);
    const allCities = statesData.flatMap((state) => state.cities);

    // All language codes and objects
    const allLangCodes = languages.map((lang) => lang.short_name);
    const languageObjects = languages.map(({ name, short_name }) => ({
      name,
      short_name,
    }));

    // All genders
    const allGenders = [];

    // Apply all defaults to state
    setSelectedState([]);
    setSelectedCity([]);
    setCities([]);
    setSelectedLanguages([]);
    setSelectedGenders([]);
    setSelectedAge([]);

    // Update form state with full default values
    setCampaignFormCreate((prev) => ({
      ...prev,
      state: [],
      city: "",
      language: [],
      gender: [],
      age_group: [],
    }));
  }, []);

  const handleAgeSelect = (age) => {
    const normalizedAgeGroups = ageGroups.map((a) => a.replace(/\s+/g, ""));

    if (age === "Select All") {
      const isAllSelected =
        selectedAge.length === normalizedAgeGroups.length &&
        normalizedAgeGroups.every((a) => selectedAge.includes(a));

      const newSelection = isAllSelected ? [] : normalizedAgeGroups;

      setSelectedAge(newSelection);
      setCampaignFormCreate((prev) => ({
        ...prev,
        age_group: newSelection,
      }));
    } else if (age === "Clear All") {
      setSelectedAge([]);
      setCampaignFormCreate((prev) => ({
        ...prev,
        age_group: [],
      }));
    } else {
      setSelectedAge((prevSelectedAge) => {
        const alreadySelected = prevSelectedAge.includes(age);
        const updatedSelectedAge = alreadySelected
          ? prevSelectedAge.filter((a) => a !== age)
          : [...prevSelectedAge, age];

        // Sort by starting age number
        const sorted = updatedSelectedAge.sort((a, b) => {
          const getStart = (str) =>
            parseInt(str.replace("+", "").split("-")[0].trim());
          return getStart(a) - getStart(b);
        });

        setCampaignFormCreate((prev) => ({
          ...prev,
          age_group: sorted,
        }));

        return sorted;
      });
    }
  };

  const openCalendar = (inputId) => {
    const inputElement = document.getElementById(inputId);
    if (inputElement) {
      inputElement.showPicker(); // Open the date picker
    }
  };

  const convertToFormData = (payload) => {
    const formData = new FormData();

    // Append all key-value pairs from the payload
    Object.keys(payload).forEach((key) => {
      if (payload[key] instanceof File || payload[key] instanceof Blob) {
        // If the value is a file, append it directly
        formData.append(key, payload[key]);
      } else if (typeof payload[key] === "object" && payload[key] !== null) {
        // Convert objects (like timeline) to JSON strings
        formData.append(key, JSON.stringify(payload[key]));
      } else {
        // Append other primitive types
        formData.append(key, payload[key]);
      }
    });

    return formData;
  };

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formattedTimeline = timeLine.map((weekData, index) => ({
      week: index + 1,
      Instagram: {
        reels: weekData?.Instagram?.reels || 0,
        posts: weekData?.Instagram?.posts || 0,
        story: weekData?.Instagram?.story || 0,
      },
      YouTube: {
        shorts: weekData?.YouTube?.shorts || 0,
        videos: weekData?.YouTube?.videos || 0,
        live_stream: weekData?.YouTube?.live_stream || 0,
      },
    }));

    const formData = new FormData();

    Object.keys(CampaignFormCreate).forEach((key) => {
      const value = CampaignFormCreate[key];

      if (value === null || value === undefined) return;

      if (key === "file") {
        const fileData = value;

        if (fileData?.buffer) {
          const blob = new Blob([fileData.buffer], { type: fileData.mimetype });
          formData.append("file", blob, fileData.originalname);
        } else if (fileData instanceof File) {
          formData.append("file", fileData);
        } else {
          console.error("Invalid file format:", fileData);
        }
      } else if (key === "language") {
        formData.append("language", JSON.stringify(value));
      } else if (key === "timeline") {
        // Skip here – we append below
      } else {
        formData.append(key, value);
      }
    });

    formData.append("timeline", JSON.stringify(formattedTimeline));

    if (startDate) {
      formData.append("start_date", startDate);
    }
    if (endDate) {
      formData.append("end_date", endDate);
    }

    formData.append("issavedasdraft", false);
    formData.append("campaign_hashtag", "");
    formData.append("campaign_id", id || "");
    formData.append("ispublished", 1);
    if (id) {
      formData.append("flag_update", true);
    }

    try {
      const response = await axiosMain.post(
        "/api/v1/create-campaign",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 201 || response.status === 200) {
        resetForm();
        setTimeLine([]);
        navigate("/campaign");
      }
    } catch (error) {
      console.error("Error saving campaign:", error);
    }
  };

  const handleSaveDraft = async (e) => {
    e.preventDefault();

    const formattedTimeline = timeLine.map((weekData, index) => ({
      week: index + 1,
      Instagram: {
        reels: weekData?.Instagram?.reels || 0,
        posts: weekData?.Instagram?.posts || 0,
        story: weekData?.Instagram?.story || 0,
      },
      YouTube: {
        shorts: weekData?.YouTube?.shorts || 0,
        videos: weekData?.YouTube?.videos || 0,
        live_stream: weekData?.YouTube?.live_stream || 0,
      },
    }));

    const formData = new FormData();

    Object.keys(CampaignFormCreate).forEach((key) => {
      const value = CampaignFormCreate[key];

      if (value === null || value === undefined) return;

      if (key === "file") {
        const fileData = value;

        if (fileData?.buffer) {
          const blob = new Blob([fileData.buffer], { type: fileData.mimetype });
          formData.append("file", blob, fileData.originalname);
        } else if (fileData instanceof File) {
          formData.append("file", fileData);
        } else {
          console.error("Invalid file format:", fileData);
        }
      } else if (key === "language") {
        formData.append("language", JSON.stringify(value));
      } else if (key === "timeline") {
        // Skip here – we append below
      } else {
        formData.append(key, value);
      }
    });

    formData.append("timeline", JSON.stringify(formattedTimeline));

    if (startDate) {
      formData.append("start_date", startDate);
    }
    if (endDate) {
      formData.append("end_date", endDate);
    }

    formData.append("issavedasdraft", true);
    formData.append("campaign_hashtag", "");
    formData.append("campaign_id", id || "");
    if (id) {
      formData.append("flag_update", true);
    }

    try {
      const response = await axiosMain.post(
        "/api/v1/create-campaign",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 201 || response.status === 200) {
        resetForm();
        setTimeLine([]);
        navigate("/campaign");
      }
    } catch (error) {
      console.error("Error saving campaign:", error);
    }
  };

  useEffect(() => {
    // All state and city data
    const allStateCodes = statesData.map((state) => state.iso2);
    const allCities = statesData.flatMap((state) => state.cities);

    // All language codes and objects
    const allLangCodes = languages.map((lang) => lang.short_name);
    const languageObjects = languages.map(({ name, short_name }) => ({
      name,
      short_name,
    }));

    // All genders
    const allGenders = [];

    // Apply all defaults to state
    setSelectedState([]);
    setSelectedCity([]);
    setCities([]);
    setSelectedLanguages([]);
    setSelectedGenders([]);
    setSelectedAge([]);

    // Update form state with full default values
    setCampaignFormCreate((prev) => ({
      ...prev,
      state: [],
      city: [],
      language: [],
      gender: [],
      age_group: [],
    }));
  }, []);

  useEffect(() => {
    const isDraft = JSON.parse(localStorage.getItem("issavedasdraft"));
    if (isDraft) {
      localStorage.removeItem("issavedasdraft");
    }
  }, []);

  const generateTimeline = () => {
    const { start_date, end_date } = CampaignFormCreate;

    // Parse the start and end date strings to Date objects
    const startDate = parseISO(start_date);
    const endDate = parseISO(end_date);

    // Calculate the number of weeks between the two dates
    const numWeeks = differenceInWeeks(endDate, startDate) + 1; // +1 to include both start and end week

    const newTimeline = [];

    for (let week = 1; week <= numWeeks; week++) {
      // Calculate the start and end date of the current week
      const weekStartDate = addWeeks(startDate, week - 1);
      const weekEndDate = addWeeks(startDate, week);

      // Format the dates for display or other needs
      const weekStartFormatted = format(weekStartDate, "dd/MM/yyyy");
      const weekEndFormatted = format(weekEndDate, "dd/MM/yyyy");

      // Push the new week data into the timeline
      newTimeline.push({
        week,
        YouTube: {
          shorts: 1,
          videos: 0,
          live_stream: 1,
        },
        Instagram: {
          posts: 0,
          reels: 1,
          story: 1,
        },
        week_dates: `${weekStartFormatted} to ${weekEndFormatted}`,
      });
    }

    // Update the CampaignFormCreate state with the generated timeline
    setCampaignFormCreate((prevState) => ({
      ...prevState,
      timeline: newTimeline,
    }));
  };
  const formatDeliverableName = (key) => {
    return key
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  // Effect hook to trigger when start or end date changes
  useEffect(() => {
    if (CampaignFormCreate?.start_date && CampaignFormCreate?.end_date) {
      generateTimeline();
    }
  }, [CampaignFormCreate?.start_date, CampaignFormCreate?.end_date]);

  const calculateWeeks = (start, end) => {
    const startDt = new Date(start);
    const endDt = new Date(end);
    const diffTime = Math.abs(endDt - startDt);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return Math.ceil(diffDays / 7);
  };

  const handleCountChange = (week, platform, activity, isIncrement) => {
    setTimeLine((prev) => {
      // Clone the previous state to avoid mutations
      let updatedTimeLine = [...prev];

      // Find the index of the week in the timeline
      let weekIndex = updatedTimeLine.findIndex((w) => w.week === week);

      if (weekIndex === -1) {
        // If week doesn't exist, initialize it with default values (all 0)
        updatedTimeLine.push({
          week,
          Instagram: { reels: 0, posts: 0, story: 0 },
          YouTube: { shorts: 0, videos: 0, live_stream: 0 },
        });
        weekIndex = updatedTimeLine.length - 1; // Get the new week's index
      }

      // Ensure platform exists within the week (prevents undefined errors)
      if (!updatedTimeLine[weekIndex][platform]) {
        updatedTimeLine[weekIndex][platform] = {};
      }

      // Get the current count (default to 0 if undefined)
      const currentCount = updatedTimeLine[weekIndex][platform][activity] ?? 0;

      // Calculate new value (ensuring it doesn't go below 0)
      const newValue = isIncrement
        ? currentCount + 1
        : Math.max(0, currentCount - 1);

      // Update the specific activity count
      updatedTimeLine[weekIndex] = {
        ...updatedTimeLine[weekIndex],
        [platform]: {
          ...updatedTimeLine[weekIndex][platform],
          [activity]: newValue,
        },
      };

      return updatedTimeLine;
    });
  };

  const weeksCount =
    startDate && endDate ? calculateWeeks(startDate, endDate) : 0;

  // Handle state selection
  // changes do for select all option
  const handleStateChange = (value) => {
    const allStateCodes = statesData.map((state) => state.iso2);

    if (!value || value.length === 0) {
      setSelectedState([]);
      setSelectedCity([]);
      setCities([]);
      setCampaignFormCreate((prev) => ({
        ...prev,
        state: [],
        city: [],
      }));
      return;
    }

    if (value.includes("all")) {
      const isAllSelected =
        selectedState.length === allStateCodes.length &&
        allStateCodes.every((code) => selectedState.includes(code));

      if (isAllSelected) {
        // Deselect all
        setSelectedState([]);
        setSelectedCity([]);
        setCities([]);
        setCampaignFormCreate((prev) => ({
          ...prev,
          state: [],
          city: [],
        }));
      } else {
        // Select all
        setSelectedState(allStateCodes);
        const allCities = statesData.flatMap((state) => state.cities || []);
        setCities(allCities);
        setSelectedCity([]);
        setCampaignFormCreate((prev) => ({
          ...prev,
          state: allStateCodes,
          city: [],
        }));
      }
    } else {
      // Regular state selection
      const cleanedSelection = value.filter((v) => v !== "all");
      setSelectedState(cleanedSelection);

      const selectedStates = statesData.filter((state) =>
        cleanedSelection.includes(state.iso2)
      );
      const newCities = selectedStates.flatMap((state) => state.cities || []);
      setCities(newCities);

      const updatedSelectedCity = selectedCity.filter((city) =>
        newCities.includes(city)
      );

      setSelectedCity(updatedSelectedCity);
      setCampaignFormCreate((prev) => ({
        ...prev,
        state: cleanedSelection,
        city: updatedSelectedCity,
      }));
    }
  };

  const handleCityChange = (value) => {
    const allCityValues = cities.filter((city) => city !== "Pan India");
    const isSelectAll = value.includes("selectAll");

    if (!value || value.length === 0) {
      // Nothing selected
      setSelectedCity([]);
      setCampaignFormCreate((prev) => ({
        ...prev,
        city: [],
      }));
      return;
    }

    if (isSelectAll) {
      const isAllSelected =
        selectedCity.length === allCityValues.length &&
        allCityValues.every((city) => selectedCity.includes(city));

      if (isAllSelected) {
        // Deselect all
        setSelectedCity([]);
        setCampaignFormCreate((prev) => ({
          ...prev,
          city: [],
        }));
      } else {
        // Select all cities (excluding "Pan India")
        setSelectedCity(allCityValues);
        setCampaignFormCreate((prev) => ({
          ...prev,
          city: allCityValues,
        }));
      }
    } else if (value.includes("Pan India")) {
      // Special Pan India case
      setSelectedCity(["Pan India"]);
      setCampaignFormCreate((prev) => ({
        ...prev,
        city: "Pan India",
      }));
    } else {
      // Manual selection (remove "selectAll" and "Pan India" just in case)
      const cleanedSelection = value.filter(
        (city) => city !== "selectAll" && city !== "Pan India"
      );
      setSelectedCity(cleanedSelection);
      setCampaignFormCreate((prev) => ({
        ...prev,
        city: cleanedSelection,
      }));
    }
  };

  // This function is used to ensure that if all cities are selected, "Select All" is checked, and vice versa
  const isAllCitiesSelected = () => {
    return cities.length === selectedCity.length; // Check if all cities are selected
  };

  useEffect(() => {
    setSelectedAge([]);
  }, []);
  // this functionality do for language show select all and show all language in tooltip
  const fetchLanguages = async () => {
    try {
      const response = await axiosMain.get("/api/v1/languages"); // Modify the API endpoint if needed
      if (response.data && Array.isArray(response.data.data)) {
        setLanguages(response.data.data); // Set the fetched languages
      } else {
        console.error("Invalid data format from API");
      }
    } catch (err) {
      console.error("Failed to fetch languages:", err);
    }
  };

  useEffect(() => {
    fetchLanguages();
  }, []);

  const handleLanguageChange = (selected) => {
    const allLanguageCodes = languages.map((lang) => lang.short_name);
    const isSelectAll = selected.includes("selectAll");

    if (isSelectAll) {
      const isAllAlreadySelected =
        selectedLanguages.length === allLanguageCodes.length &&
        allLanguageCodes.every((code) => selectedLanguages.includes(code));

      if (isAllAlreadySelected) {
        // Deselect all
        setSelectedLanguages([]);
        setCampaignFormCreate((prev) => ({
          ...prev,
          language: [],
        }));
        return;
      } else {
        // Select all
        const languageObjects = languages.map(({ name, short_name }) => ({
          name,
          short_name,
        }));

        setSelectedLanguages(allLanguageCodes);
        setCampaignFormCreate((prev) => ({
          ...prev,
          language: languageObjects,
        }));
        return;
      }
    }

    // Regular language selection (excluding "selectAll")
    const updatedLanguages = selected.filter((lang) => lang !== "selectAll");
    setSelectedLanguages(updatedLanguages);

    const languageObjects = languages
      .filter((lang) => updatedLanguages.includes(lang.short_name))
      .map(({ name, short_name }) => ({ name, short_name }));

    setCampaignFormCreate((prev) => ({
      ...prev,
      language: languageObjects,
    }));
  };

  const MAX_LANGUAGES = 4;

  // Ensure selectedLanguages is an array and map it to their full names
  const selectedLangNames = Array.isArray(selectedLanguages)
    ? selectedLanguages.map((shortName) => {
        const lang = languages.find(
          (language) => language.short_name === shortName
        );
        return lang ? lang.name : shortName;
      })
    : []; // Default to an empty array if selectedLanguages is not an array

  // Check if the number of selected languages exceeds MAX_LANGUAGES
  const showMoreLanguages = selectedLangNames.length > MAX_LANGUAGES;
  const handleGenderChange = (event) => {
    const selected = event.target.value;
    const allGenders = ["male", "female", "other"];

    if (selected.includes("all")) {
      // If all genders are already selected, toggle off (deselect all)
      const isAllSelected =
        selectedGenders.length === allGenders.length &&
        allGenders.every((gender) => selectedGenders.includes(gender));

      if (isAllSelected) {
        // Deselect all
        setSelectedGenders([]);
        setCampaignFormCreate((prev) => ({
          ...prev,
          gender: [],
        }));
      } else {
        // Select all
        setSelectedGenders(allGenders);
        setCampaignFormCreate((prev) => ({
          ...prev,
          gender: allGenders,
        }));
      }
    } else {
      // Normal selection (remove "all" and update state)
      const cleanedSelection = selected.filter((val) => val !== "all");
      setSelectedGenders(cleanedSelection);
      setCampaignFormCreate((prev) => ({
        ...prev,
        gender: cleanedSelection,
      }));
    }
  };

  // Custom circle (green when active/completed, gray otherwise)
  const CustomStepIcon = styled("div")(({ theme, ownerState }) => ({
    width: 30,
    height: 30,
    borderRadius: "50%",
    backgroundColor: ownerState.completed ? "#4caf50" : "#cfd8dc", // green or gray
    display: "inline-block",
  }));

  // function StepIconComponent(props) {
  //   const { active, completed } = props;
  //   return <CustomStepIcon ownerState={{ active, completed }} />;
  // }

  useEffect(() => {
    if (CampaignFormCreate?.language?.length > 0 && languages.length > 0) {
      // Map short names from API response
      const defaultSelectedLanguages = CampaignFormCreate.language.map(
        (lang) => lang.short_name
      );

      // Optional: Re-sync language objects into form state if needed
      const languageObjects = languages
        .filter((lang) => defaultSelectedLanguages.includes(lang.short_name))
        .map((lang) => ({
          name: lang.name,
          short_name: lang.short_name,
        }));

      setCampaignFormCreate((prev) => ({
        ...prev,
        language: languageObjects,
      }));
    }

    if (CampaignFormCreate?.age_group?.length > 0) {
      setSelectedAge(CampaignFormCreate.age_group); // Set age group buttons
    }
  }, []);

  const { id } = useParams();
  useEffect(() => {
    const fetchCampaign = async () => {
      try {
        const response = await axiosMain.get("/api/v1/campaigns", {
          params: { campaign_id: id },
        });

        const campaign = response.data?.campaigns?.[0];

        if (campaign) {
          // ✅ Set other data fields
          setCampaignFormCreate(campaign);
          setSelectedState(Array.isArray(campaign.state) ? campaign.state : []);
          setSelectedCity(Array.isArray(campaign.city) ? campaign.city : []);

          // ✅ Populate cities based on selected state
          if (Array.isArray(campaign.state) && campaign.state.length > 0) {
            const selectedStates = statesData.filter((state) =>
              campaign.state.includes(state.iso2)
            );
            const allCities = selectedStates.flatMap((state) => state.cities);
            setCities(allCities); // ✅ Set the cities list so that selected city appears correctly
          }

          if (campaign?.budget) {
            setMinBudget(Number(campaign.budget));
            setMaxBudget(5000000);
          }

          if (campaign?.age_group && Array.isArray(campaign.age_group)) {
            const normalize = (str) => str.replace(/\s+/g, "");
            const uniqueAgeGroups = [
              ...new Set(campaign.age_group.map((age) => normalize(age))),
            ];
            setSelectedAge(uniqueAgeGroups);
          }
          if (campaign?.launch_date) {
            const utcDate = new Date(campaign.launch_date);
            const localDate = new Date(
              utcDate.getTime() + utcDate.getTimezoneOffset() * 60000
            );
            setLocalLaunchDate(localDate.toISOString().split("T")[0]); // Format YYYY-MM-DD
          }
          setSelectedLanguages(
            Array.isArray(campaign.language)
              ? campaign.language.map((lang) => lang.short_name)
              : []
          );
          setSelectedImage(campaign.campaign_poster);

          // ✅ Gender (Set Default Gender)
          if (Array.isArray(campaign.gender)) {
            setSelectedGenders(campaign.gender); // Set the selected genders
          }

          // ✅ Basic Form Fields
          setCampaignFormCreate({
            campaign_title: campaign.campaign_title || "",
            product_name: campaign.product_name || "",
            launch_date: campaign.launch_date
              ? campaign.launch_date.split("T")[0]
              : "",
            campaign_primary_objective:
              campaign.campaign_primary_objective || "",
            campaign_secondary_objective:
              campaign.campaign_secondary_objective || "",
            description: campaign.description || "",
            compensation_type: campaign.compensation_type || "",
            budget: campaign.budget || "",
          });

          // ✅ Timeline Handling
          if (campaign?.timeline && Array.isArray(campaign.timeline)) {
            setTimeLine(campaign.timeline); // Set received timeline
          } else {
            // Default timeline if none exists
            setTimeLine([
              {
                week: 1,
                Instagram: { reels: 0, posts: 0, story: 0 },
                YouTube: { shorts: 0, videos: 0, live_stream: 0 },
              },
            ]);
          }

          // ✅ Dates handling
          if (campaign.start_date) {
            setStartDate(
              new Date(campaign.start_date).toISOString().split("T")[0]
            );
          }
          if (campaign.end_date) {
            setEndDate(new Date(campaign.end_date).toISOString().split("T")[0]);
          }
        }
      } catch (error) {
        console.error("Error fetching campaign:", error);
      }
    };

    if (id) {
      fetchCampaign();
    }
  }, [id]);

  const CustomStepConnector = styled(StepConnector)(({ theme }) => ({
    "&.Mui-active": {
      "& .MuiStepConnector-line": {
        backgroundColor: "#6b8e76",
      },
    },
    "&.Mui-completed": {
      "& .MuiStepConnector-line": {
        backgroundColor: "#6b8e76",
      },
    },
    "& .MuiStepConnector-line": {
      height: 3,
      border: 0,
      backgroundColor: "#e0e0e0",
      borderRadius: 1,
    },
  }));

  const StepIconComponent = (props) => {
    const { active, completed, className } = props;

    return (
      <Box
        className={className}
        sx={{
          width: 30,
          height: 30,
          borderRadius: "50%",
          border: active ? "3px solid #6b8e76" : "2px solid #e0e0e0",
          backgroundColor: completed ? "#6b8e76" : "transparent",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {completed ? (
          <CheckIcon sx={{ fontSize: 18, color: "white" }} />
        ) : active ? (
          <Box
            sx={{
              width: 12,
              height: 12,
              borderRadius: "50%",
              backgroundColor: "#6b8e76",
            }}
          />
        ) : null}
      </Box>
    );
  };

  return (
    <div className="campaignCreate">
      <div className="campaign-container">
        {/* Progress Steps */}
        {/* Form Content */}
        <div className="form-content">
          <Card
            sx={{
              width: "100%",
              p: 2,
              mb: 5,
              boxShadow: "none",
              border: "1px solid #EEEEEE",
              borderRadius: "16px",
            }}
          >
            <CardContent>
              <Box sx={{ width: "100%" }}>
                <Stepper
                  activeStep={currentStep - 1}
                  alternativeLabel
                  connector={<CustomStepConnector />}
                >
                  {steps.map((label, index) => {
                    const isActive = index === currentStep - 1;
                    const isCompleted = index < currentStep - 1;

                    return (
                      <Step key={label} completed={isCompleted}>
                        <StepLabel
                          StepIconComponent={StepIconComponent}
                          sx={{
                            "& .MuiStepLabel-label": {
                              color:
                                isActive || isCompleted ? "#6b8e76" : "#9e9e9e",
                              // fontWeight: isActive ? 600 : 400,
                            },
                          }}
                        >
                          {label}
                        </StepLabel>
                      </Step>
                    );
                  })}
                </Stepper>
              </Box>
            </CardContent>
          </Card>

          {/* Step 1: Campaign Details */}
          {currentStep === 1 && (
            <div className="campaign-step-card-wrapper">
              <div
                style={{
                  background: "#fff",
                  padding: "24px",
                  borderRadius: "12px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
                }}
              >
                <div className="step-one-campign-create">
                  <div className="upload-section mb-4">
                    <label
                      style={{
                        display: "block",
                        marginBottom: "0.5rem",
                        fontWeight: "500",
                        color: " rgba(18, 18, 18, 1)",
                        fontSize: "24px",
                      }}
                    >
                      Campaign Poster
                    </label>

                    <div
                      className="upload-box"
                      onDragOver={handleDragOver}
                      onDrop={handleDrop}
                      style={{
                        // border: "2px dashed rgba(103, 103, 103, 1)"
                        border: "2px dashed rgba(107, 142, 118, 1)",
                        padding: "20px",
                        textAlign: "center",
                        cursor: "pointer",
                        position: "relative",
                      }}
                      onClick={() =>
                        document.getElementById("file-upload").click()
                      }
                    >
                      <input
                        id="file-upload"
                        type="file"
                        accept=".jpg,.png"
                        onChange={handleFileSelect}
                        style={{ display: "none" }}
                      />

                      {selectedImage ? (
                        <img
                          src={selectedImage}
                          alt="Selected Preview"
                          style={{
                            width: "100%",
                            height: "auto",
                            maxHeight: "180px",
                            borderRadius: "8px",
                          }}
                        />
                      ) : (
                        <>
                          <img
                            src={fileicon}
                            alt="Upload Icon"
                            className="upload-icon"
                            style={{
                              width: "50px",
                              height: "50px",
                              marginBottom: "10px",
                            }}
                          />
                          <p className="upload-text">
                            Drag your file(s) or{" "}
                            <strong
                              style={{
                                color: "rgba(107, 142, 118, 1)",
                                fontWeight: "600",
                              }}
                            >
                              browse
                            </strong>
                          </p>
                          {/* <p className="upload-text">
                            Supported files:{" "}
                            <strong
                              style={{
                                color: "rgba(103, 103, 103, 1)",
                                fontWeight: "bold",
                              }}
                            >
                              JPG, PNG
                            </strong>
                          </p> */}
                          <p className="upload-text">
                            Max 10 MB files are allowed{" "}
                            <strong
                              style={{
                                color: "rgba(103, 103, 103, 1)",
                                fontWeight: "inherit",
                              }}
                            >
                              {" "}
                              {/* 5MB */}
                            </strong>
                          </p>
                        </>
                      )}
                    </div>

                    {file && (
                      <div className="file-preview">
                        <p>Selected file: {selectedFilteName}</p>
                      </div>
                    )}
                  </div>

                  <div className="row">
                    <div className="form-group col-12">
                      <label>Campaign Title</label>
                      <input
                        type="text"
                        className={`form-control ${
                          activeField === "campaign_title" ? "is-focused" : ""
                        }`}
                        placeholder="Enter Title for Your Campaign"
                        name="campaign_title"
                        value={CampaignFormCreate?.campaign_title}
                        onChange={handleChange}
                        onFocus={() => setActiveField("campaign_title")}
                        onBlur={() => setActiveField("")}
                      />
                    </div>
                    <div className="form-group col-12 col-md-6">
                      <label>Product/ Service Name</label>
                      <input
                        type="text"
                        className={`form-control ${
                          activeField === "product_name" ? "is-focused" : ""
                        }`}
                        placeholder="Enter Product/Service Name"
                        name="product_name"
                        value={CampaignFormCreate?.product_name}
                        onChange={handleChange}
                        onFocus={() => setActiveField("product_name")}
                        onBlur={() => setActiveField("")}
                      />
                    </div>

                    <div className="form-group col-12 col-md-6">
                      <label>Launch Date</label>
                      <input
                        id="launch_date_input"
                        type="date"
                        className={`form-control ${
                          activeField === "launch_date" ? "is-focused" : ""
                        }`}
                        placeholder="Give a catchy and suitable title"
                        name="launch_date"
                        value={localLaunchDate}
                        onChange={(e) => {
                          handleChange(e);
                          setLocalLaunchDate(e.target.value); // Keep it in sync
                        }}
                        onFocus={() => setActiveField("launch_date")}
                        onBlur={() => setActiveField("")}
                        onClick={() => openCalendar("launch_date_input")}
                      />
                    </div>

                    <div className="form-group col-12 col-md-6">
                      <label>Primary Objective*</label>
                      <input
                        type="text"
                        className={`form-control ${
                          activeField === "campaign_primary_objective"
                            ? "is-focused"
                            : ""
                        }`}
                        placeholder="Enter Primary Objective of Your Campaign"
                        name="campaign_primary_objective"
                        value={CampaignFormCreate?.campaign_primary_objective}
                        onChange={handleChange}
                        onFocus={() =>
                          setActiveField("campaign_primary_objective")
                        }
                        onBlur={() => setActiveField("")}
                      />
                    </div>

                    <div className="form-group col-12 col-md-6">
                      <label>
                        Secondary Objective{" "}
                        <span
                          className="text-muted"
                          style={{ fontSize: "0.975rem" }}
                        >
                          (Optional)
                        </span>
                      </label>{" "}
                      <input
                        type="text"
                        className={`form-control ${
                          activeField === "campaign_secondary_objective"
                            ? "is-focused"
                            : ""
                        }`}
                        placeholder="Enter Secondary Objective of Your Campaign"
                        name="campaign_secondary_objective"
                        value={CampaignFormCreate?.campaign_secondary_objective}
                        onChange={handleChange}
                        onFocus={() =>
                          setActiveField("campaign_secondary_objective")
                        }
                        onBlur={() => setActiveField("")}
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Description</label>
                    <Editor
                      apiKey="5xkma78g8xw8pm6g6n64noyiyy18zpy3qe9ssqj5bxc7nd5q"
                      id="description"
                      name="description"
                      textareaName="description"
                      value={CampaignFormCreate?.description || ""}
                      onEditorChange={(content) =>
                        handleChange({
                          target: {
                            name: "description",
                            value: content,
                          },
                        })
                      }
                      onFocus={() => setActiveField("description")}
                      onBlur={() => setActiveField("")}
                      init={{
                        height: 200,
                        menubar: false,
                        plugins: [
                          "advlist autolink lists link image charmap preview anchor",
                          "searchreplace visualblocks code fullscreen",
                          "insertdatetime media table paste code help wordcount",
                          "textcolor",
                          "colorpicker",
                          "lists",
                          "removeformat",
                        ],
                        toolbar:
                          "bold italic underline strikethrough | forecolor backcolor | " +
                          "fontsizeselect | link | bullist numlist | " +
                          "alignleft aligncenter alignright alignjustify | " +
                          "outdent indent | removeformat",
                        font_size_formats:
                          "8pt 10pt 12pt 14pt 16pt 18pt 24pt 36pt",
                      }}
                      className={`form-control ${
                        activeField === "description" ? "is-focused" : ""
                      }`}
                    />
                  </div>

                  <div className="row">
                    {/* <h2 className="Title">Payment and Compensation</h2> */}
                    <div className="form-group col-12 col-md-6">
                      <label>Compensation Type</label>
                      <select
                        className={`form-select ${
                          activeField === "compensation_type"
                            ? "is-focused"
                            : ""
                        }`}
                        name="compensation_type"
                        value={CampaignFormCreate?.compensation_type}
                        onChange={handleChange}
                        onFocus={() => setActiveField("compensation_type")}
                        onBlur={() => setActiveField("")}
                      >
                        <option>Select How would you pay Influencer</option>
                        <option value="Product Exclusivity">
                          Product Exclusivity
                        </option>
                        <option value="Monetary Compensation">
                          Monetary Compensation
                        </option>
                        <option value="Experiences">Experiences</option>
                      </select>
                    </div>

                    <div className="form-group col-12 col-md-6">
                      <label>Budget For Campaign</label>

                      <div
                        onFocus={() => setActiveField("budget")}
                        onBlur={() => setActiveField("")}
                        className={activeField === "budget" ? "" : ""}
                      >
                        {/* Value display */}
                        <div className="d-flex justify-content-between ">
                          <span className="text-budget fw-semibold">
                            ₹{formatNumber(minBudget)}
                          </span>
                          <span className="text-budget fw-semibold">
                            ₹{formatNumber(maxBudget)}
                          </span>
                        </div>

                        {/* Dual sliders */}
                        <div className="position-relative range-wrapper">
                          {/* Min thumb - green round */}
                          <input
                            type="range"
                            min="3000"
                            max="5000000"
                            step="1000"
                            value={minBudget}
                            onChange={(e) => {
                              setMinBudget(Number(e.target.value));
                              handleChange({
                                target: {
                                  name: "budget",
                                  value: Number(e.target.value),
                                },
                              });
                            }}
                            className="custom-range min-slider position-absolute w-100"
                            style={{ zIndex: minBudget > 0 ? 2 : 3 }}
                          />

                          {/* Max thumb - hidden thumb */}
                          <input
                            type="range"
                            min="0"
                            max="5000000"
                            step="5000"
                            value={maxBudget}
                            onChange={(e) => {
                              const val = Math.max(
                                Number(e.target.value),
                                minBudget + 5000
                              );
                              setMaxBudget(val);
                              handleChange({
                                target: {
                                  name: "budget",
                                  value: `₹${formatNumber(
                                    minBudget
                                  )} - ₹${formatNumber(val)}`,
                                },
                              });
                            }}
                            className="custom-range max-slider position-absolute w-100"
                            style={{ zIndex: 1 }}
                          />
                        </div>

                        <div className="d-flex justify-content-between">
                          <small className="text-budget fw-semibold">MIN</small>
                          <small className="text-budget fw-semibold">MAX</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Step 2: Audience */}
          {currentStep === 2 && (
            <div className="campaign-step-card-wrapper">
              <div
                style={{
                  background: "#fff",
                  padding: "24px",
                  borderRadius: "12px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
                }}
              >
                <div>
                  {/* <h2 className="Title target-audience">Target Audience</h2> */}
                  <div className="row">
                    <div className="form-group col-12 col-md-6">
                      <Box
                        display={"flex"}
                        alignItems={"start"}
                        justifyContent={"center"}
                        flexDirection={"column"}
                        rowGap={0.5}
                      >
                        <InputLabel label={"Select State"} />
                        <DropDown
                          label={"Select State"}
                          options={[
                            { value: "all", label: "Select All" }, // Select All option for state
                            ...statesData.map((state) => ({
                              value: state.iso2,
                              label: state.state,
                            })),
                          ]}
                          multiple
                          onChange={({ target: { value } }) => {
                            handleStateChange(value); // Call the function to handle state changes
                          }}
                          value={selectedState}
                        />
                      </Box>
                      <div className="chip-container">
                        {/* Check if "Pan India" is selected */}
                        {selectedState.includes("Pan India") ? (
                          <Chip
                            label="Pan India"
                            sx={{ width: "100px" }}
                            variant="outlined"
                            clickable
                            onDelete={() => {
                              // Remove "Pan India" from the selectedState
                              const filtered = selectedState.filter(
                                (sel) => sel !== "Pan India"
                              );
                              setSelectedState(filtered); // Update the selectedState without "Pan India"
                              handleStateChange(filtered); // Update state change logic
                            }}
                            style={{
                              fontSize: "8px",
                              fontFamily: "Poppins, sans-serif",
                            }}
                          />
                        ) : null}
                      </div>
                    </div>

                    <div className="form-group col-md-6">
                      <Box
                        display={"flex"}
                        alignItems={"start"}
                        justifyContent={"center"}
                        flexDirection={"column"}
                        rowGap={0.5}
                      >
                        <InputLabel label={"Select City"} />
                        <DropDown
                          label={"Select City"}
                          options={
                            cities.length
                              ? [
                                  { value: "selectAll", label: "Select All" },
                                  ...cities.map((city) => ({
                                    value: city,
                                    label: city,
                                  })),
                                ]
                              : []
                          }
                          multiple
                          onChange={({ target: { value } }) => {
                            handleCityChange(value); // Call the function to handle state changes
                          }}
                          value={selectedCity}
                        />
                      </Box>
                      <div className="chip-container">
                        {/* Show "Pan India" only if all cities are selected via "Select All" */}
                        {selectedCity.includes("Pan India") && (
                          <Chip
                            label="Pan India"
                            sx={{ width: "100px" }}
                            variant="outlined"
                            clickable
                            onDelete={() => {
                              // Remove "Pan India" and deselect all
                              setSelectedCity([]);
                              handleCityChange([]);
                            }}
                            style={{
                              fontSize: "8px",
                              fontFamily: "Poppins, sans-serif",
                            }}
                          />
                        )}
                      </div>
                    </div>

                    <div className="form-group col-12 col-md-6">
                      <Box
                        display={"flex"}
                        alignItems={"start"}
                        justifyContent={"center"}
                        flexDirection={"column"}
                        rowGap={0.5}
                      >
                        <InputLabel label={"Gender"} />
                        <DropDown
                          label={"Select Gender"}
                          options={[
                            { value: "all", label: "Select All" },
                            { value: "male", label: "Male" },
                            { value: "female", label: "Female" },
                            { value: "other", label: "Other" },
                          ]}
                          multiple
                          onChange={handleGenderChange}
                          value={selectedGenders}
                        />
                      </Box>
                    </div>

                    <div className="form-group col-12 col-md-6">
                      <Box
                        display={"flex"}
                        alignItems={"start"}
                        justifyContent={"center"}
                        flexDirection={"column"}
                        rowGap={0.5}
                      >
                        <InputLabel label={"Languages"} />
                        <DropDown
                          label={"Select Languages"}
                          options={[
                            { value: "selectAll", label: "Select All" },
                            ...languages.map((lang) => ({
                              value: lang.short_name,
                              label: lang.name,
                            })),
                          ]}
                          onChange={({ target: { value } }) =>
                            handleLanguageChange(value)
                          }
                          multiple
                          value={selectedLanguages}
                        />
                      </Box>
                    </div>

                    <div className="age-group-container">
                      <h2 className="age mb-2">
                        <span className="campign-custom-label">Age Group</span>
                        <span
                          style={{
                            fontSize: "14px",
                            fontWeight: "normal",
                            color: "#6c757d",
                          }}
                        >
                          (Select Your audience’s Age Group)
                        </span>
                      </h2>

                      <div className="d-flex justify-content-between mt-3">
                        <button
                          name="select-all"
                          className={`btn btn-sm border-0 ${
                            selectedAge.length === ageGroups.length
                              ? "selected"
                              : ""
                          }`}
                          onClick={(e) => {
                            e.preventDefault();
                            handleAgeSelect("Select All");
                          }}
                        >
                          Select All
                        </button>

                        <button
                          name="clear-all"
                          className="btn btn-sm border-0 text-danger"
                          onClick={(e) => {
                            e.preventDefault();
                            handleAgeSelect("Clear All");
                          }}
                        >
                          Clear All
                        </button>
                      </div>

                      <div className="age-buttons flex-wrap d-flex gap-4 mt-3">
                        {ageGroups.map((age) => {
                          const normalizedAge = age.replace(/\s+/g, ""); // e.g., "+ 18-21" => "+18-21"
                          return (
                            <button
                              key={age}
                              className={`age-button ${
                                selectedAge.includes(normalizedAge)
                                  ? "selected"
                                  : ""
                              }`}
                              onClick={(e) => {
                                e.preventDefault();
                                handleAgeSelect(normalizedAge);
                              }}
                            >
                              {age}
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Step 3: Deliverables */}
          {currentStep === 3 && (
            <div className="campaign-step-card-wrapper">
              <div
                style={{
                  background: "#fff",
                  padding: "24px",
                  borderRadius: "16px",
                  // boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
                  border: "1px solid #EEEEEE",
                }}
              >
                <div
                  className="CampaignTimeLine
             row g-0"
                >
                  <div className="row">
                    <div className="col-md-6 form-group col-12">
                      <label>Campaign Start Date</label>
                      <input
                        id="end_date"
                        type="date"
                        className={`form-control ${
                          activeField === "start_date" ? "is-focused" : ""
                        }`}
                        min={new Date().toISOString().split("T")[0]}
                        value={startDate}
                        name="start_date"
                        onChange={(e) => setStartDate(e.target.value)}
                        onFocus={() => setActiveField("start_date")}
                        onBlur={() => setActiveField("")}
                        onClick={() => openCalendar("end_date")}
                      />
                    </div>

                    <div className="col-md-6 form-group col-12">
                      <label>Campaign End Date</label>
                      <input
                        id="campaign_end_date_input"
                        type="date"
                        className={`form-control ${
                          activeField === "end_date" ? "is-focused" : ""
                        }`}
                        min={
                          startDate || new Date().toISOString().split("T")[0]
                        }
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        onFocus={() => setActiveField("end_date")}
                        onBlur={() => setActiveField("")}
                        name="end_date"
                        disabled={!startDate}
                        onClick={() => openCalendar("campaign_end_date_input")}
                      />
                    </div>
                  </div>

                  {weeksCount > 0 && (
                    <div>
                      <ul className="nav nav-tabs" id="weekTabs" role="tablist">
                        {[...Array(weeksCount)].map((_, i) => (
                          <li className="nav-item" role="presentation" key={i}>
                            <button
                              className={`nav-link ${i === 0 ? "active" : ""}`}
                              id={`week-${i + 1}-tab`}
                              data-bs-toggle="tab"
                              data-bs-target={`#week-${i + 1}`}
                              type="button"
                              role="tab"
                              aria-controls={`week-${i + 1}`}
                              aria-selected={i === 0}
                            >
                              Week {i + 1}
                            </button>
                          </li>
                        ))}
                      </ul>

                      <div className="tab-content mt-3" id="weekTabsContent">
                        {[...Array(weeksCount)].map((_, i) => (
                          <div
                            className={`tab-pane fade ${
                              i === 0 ? "show active" : ""
                            }`}
                            id={`week-${i + 1}`}
                            role="tabpanel"
                            aria-labelledby={`week-${i + 1}-tab`}
                            key={i}
                          >
                            <div
                              className="accordion"
                              id={`accordion-week-${i + 1}`}
                            >
                              {/* Instagram Accordion Item */}
                              <div className="row">
                                <div className="col-md-6">
                                  {/* Instagram Accordion */}
                                  <div className="accordion-item mb-3">
                                    <h2
                                      className="accordion-header"
                                      id={`headingInsta-${i}`}
                                    >
                                      <button
                                        className="accordion-button collapsed d-flex align-items-center gap-2"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target={`#collapseInsta-${i}`}
                                        aria-expanded="false"
                                        aria-controls={`collapseInsta-${i}`}
                                      >
                                        <img
                                          src={instadeliverables}
                                          alt="Instagram"
                                          style={{
                                            width: "20px",
                                            height: "20px",
                                          }}
                                        />
                                        Instagram
                                      </button>
                                    </h2>
                                    <div
                                      id={`collapseInsta-${i}`}
                                      className="accordion-collapse collapse"
                                      aria-labelledby={`headingInsta-${i}`}
                                      data-bs-parent={`#accordion-week-${
                                        i + 1
                                      }`}
                                    >
                                      <div className="accordion-body text-center insta-accordion-body">
                                        <div className="d-flex flex-wrap gap-2">
                                          {["reels", "posts", "story"].map(
                                            (activity) => (
                                              <div
                                                key={activity}
                                                className="d-flex align-items-center"
                                              >
                                                <span className="me-2 text-capitalize activity-label">
                                                  {activity}
                                                </span>
                                                <div className="Counter">
                                                  <button
                                                    className="btn btn-outline-secondary btn-sm me-2"
                                                    onClick={() =>
                                                      handleCountChange(
                                                        i + 1,
                                                        "Instagram",
                                                        activity,
                                                        false
                                                      )
                                                    }
                                                  >
                                                    -
                                                  </button>
                                                  <span className="me-2 count-value">
                                                    {timeLine.find(
                                                      (w) => w.week === i + 1
                                                    )?.Instagram[activity] || 0}
                                                  </span>
                                                  <button
                                                    className="btn btn-outline-secondary btn-sm"
                                                    onClick={() =>
                                                      handleCountChange(
                                                        i + 1,
                                                        "Instagram",
                                                        activity,
                                                        true
                                                      )
                                                    }
                                                  >
                                                    +
                                                  </button>
                                                </div>
                                              </div>
                                            )
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-md-6">
                                  {/* YouTube Accordion */}
                                  <div className="accordion-item mb-3">
                                    <h2
                                      className="accordion-header"
                                      id={`headingYT-${i}`}
                                    >
                                      <button
                                        className="accordion-button collapsed custom-accordion-btn"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target={`#collapseYT-${i}`}
                                        aria-expanded="false"
                                        aria-controls={`collapseYT-${i}`}
                                      >
                                        <img
                                          src={youtubedeliverables}
                                          alt="YouTube"
                                          className="accordion-icon"
                                        />
                                        YouTube
                                      </button>
                                    </h2>
                                    <div
                                      id={`collapseYT-${i}`}
                                      className="accordion-collapse collapse"
                                      aria-labelledby={`headingYT-${i}`}
                                      data-bs-parent={`#accordion-week-${
                                        i + 1
                                      }`}
                                    >
                                      <div className="accordion-body text-center">
                                        <div className="d-flex  gap-2">
                                          {[
                                            "shorts",
                                            "videos",
                                            "live_stream",
                                          ].map((activity) => (
                                            <div
                                              key={activity}
                                              className="d-flex align-items-center"
                                            >
                                              <span className="me-2 text-capitalize">
                                                {activity}
                                              </span>
                                              <div className="Counter">
                                                <button
                                                  className="btn btn-outline-secondary btn-sm me-2"
                                                  onClick={() =>
                                                    handleCountChange(
                                                      i + 1,
                                                      "YouTube",
                                                      activity,
                                                      false
                                                    )
                                                  }
                                                >
                                                  -
                                                </button>
                                                <span className="me-2">
                                                  {timeLine.find(
                                                    (w) => w.week === i + 1
                                                  )?.YouTube[activity] || 0}
                                                </span>
                                                <button
                                                  className="btn btn-outline-secondary btn-sm"
                                                  onClick={() =>
                                                    handleCountChange(
                                                      i + 1,
                                                      "YouTube",
                                                      activity,
                                                      true
                                                    )
                                                  }
                                                >
                                                  +
                                                </button>
                                              </div>
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Facebook Accordion Item */}
                              {/* <div className="accordion-item mb-3">
                                <h2
                                  className="accordion-header"
                                  id={`headingFB-${i}`}
                                >
                                  <button
                                    className="accordion-button collapsed custom-accordion-btn"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#collapseFB-${i}`}
                                    aria-expanded="false"
                                    aria-controls={`collapseFB-${i}`}
                                  >
                                    <img
                                      src={facebookaccordian}
                                      alt="Facebook"
                                      className="accordion-icon"
                                    />
                                    Facebook
                                  </button>
                                </h2>

                                <div
                                  id={`collapseFB-${i}`}
                                  className="accordion-collapse collapse"
                                  aria-labelledby={`headingFB-${i}`}
                                  data-bs-parent={`#accordion-week-${i + 1}`}
                                >
                                  <div className="accordion-body text-center">
                                    <div className="d-flex flex-wrap gap-3">
                                      {["Reels", "Stories", "Posts"].map(
                                        (activity) => (
                                          <div
                                            key={activity}
                                            className="d-flex align-items-center"
                                          >
                                            <span className="me-2 text-capitalize">
                                              {activity}
                                            </span>
                                            <div className="Counter">
                                              <button
                                                className="btn btn-outline-secondary btn-sm me-2"
                                                onClick={() =>
                                                  handleCountChange(
                                                    i + 1,
                                                    "Facebook",
                                                    activity,
                                                    false
                                                  )
                                                }
                                              >
                                                -
                                              </button>
                                              <span className="me-2">
                                                {timeLine.find(
                                                  (w) => w.week === i + 1
                                                )?.Facebook[activity] || 0}
                                              </span>
                                              <button
                                                className="btn btn-outline-secondary btn-sm"
                                                onClick={() =>
                                                  handleCountChange(
                                                    i + 1,
                                                    "Facebook",
                                                    activity,
                                                    true
                                                  )
                                                }
                                              >
                                                +
                                              </button>
                                            </div>
                                          </div>
                                        )
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div> */}
                              {/* Twitter Accordion Item */}
                              {/* <div className="accordion-item mb-3">
                                <h2
                                  className="accordion-header"
                                  id={`headingTwitter-${i}`}
                                >
                                  <button
                                    className="accordion-button collapsed custom-accordion-btn"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#collapseTwitter-${i}`}
                                    aria-expanded="false"
                                    aria-controls={`collapseTwitter-${i}`}
                                  >
                                    <img
                                      src={twiteraccordian}
                                      alt="Twitter"
                                      className="accordion-icon"
                                    />
                                    Twitter/X{" "}
                                  </button>
                                </h2>

                                <div
                                  id={`collapseTwitter-${i}`}
                                  className="accordion-collapse collapse"
                                  aria-labelledby={`headingTwitter-${i}`}
                                  data-bs-parent={`#accordion-week-${i + 1}`}
                                >
                                  <div className="accordion-body text-center">
                                    <div className="d-flex flex-wrap gap-3">
                                      {["tweets", "Threads", "Media Posts"].map(
                                        (activity) => (
                                          <div
                                            key={activity}
                                            className="d-flex align-items-center"
                                          >
                                            <span className="me-2 text-capitalize">
                                              {activity}
                                            </span>
                                            <div className="Counter">
                                              <button
                                                className="btn btn-outline-secondary btn-sm me-2"
                                                onClick={() =>
                                                  handleCountChange(
                                                    i + 1,
                                                    "Twitter",
                                                    activity,
                                                    false
                                                  )
                                                }
                                              >
                                                -
                                              </button>
                                              <span className="me-2">
                                                {timeLine.find(
                                                  (w) => w.week === i + 1
                                                )?.Twitter[activity] || 0}
                                              </span>
                                              <button
                                                className="btn btn-outline-secondary btn-sm"
                                                onClick={() =>
                                                  handleCountChange(
                                                    i + 1,
                                                    "Twitter",
                                                    activity,
                                                    true
                                                  )
                                                }
                                              >
                                                +
                                              </button>
                                            </div>
                                          </div>
                                        )
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div> */}
                              {/* Snapchat Accordion Item */}
                              {/* <div className="accordion-item mb-3">
                                <h2
                                  className="accordion-header"
                                  id={`headingSnap-${i}`}
                                >
                                  <button
                                    className="accordion-button collapsed custom-accordion-btn"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#collapseSnap-${i}`}
                                    aria-expanded="false"
                                    aria-controls={`collapseSnap-${i}`}
                                  >
                                    <img
                                      src={snapchataccordian}
                                      alt="Snapchat"
                                      className="accordion-icon"
                                    />
                                    Snapchat
                                  </button>
                                </h2>

                                <div
                                  id={`collapseSnap-${i}`}
                                  className="accordion-collapse collapse"
                                  aria-labelledby={`headingSnap-${i}`}
                                  data-bs-parent={`#accordion-week-${i + 1}`}
                                >
                                  <div className="accordion-body text-center">
                                    <div className="d-flex flex-wrap gap-3">
                                      {["Snaps", "Stories"].map((activity) => (
                                        <div
                                          key={activity}
                                          className="d-flex align-items-center"
                                        >
                                          <span className="me-2 text-capitalize">
                                            {activity}
                                          </span>
                                          <div className="Counter">
                                            <button
                                              className="btn btn-outline-secondary btn-sm me-2"
                                              onClick={() =>
                                                handleCountChange(
                                                  i + 1,
                                                  "Snapchat",
                                                  activity,
                                                  false
                                                )
                                              }
                                            >
                                              -
                                            </button>
                                            <span className="me-2">
                                              {timeLine.find(
                                                (w) => w.week === i + 1
                                              )?.Snapchat[activity] || 0}
                                            </span>
                                            <button
                                              className="btn btn-outline-secondary btn-sm"
                                              onClick={() =>
                                                handleCountChange(
                                                  i + 1,
                                                  "Snapchat",
                                                  activity,
                                                  true
                                                )
                                              }
                                            >
                                              +
                                            </button>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                </div>
                              </div> */}
                              {/* LinkedIn Accordion Item */}
                              {/* <div className="accordion-item mb-3">
                                <h2
                                  className="accordion-header"
                                  id={`headingLinkedIn-${i}`}
                                >
                                  <button
                                    className="accordion-button collapsed custom-accordion-btn"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#collapseLinkedIn-${i}`}
                                    aria-expanded="false"
                                    aria-controls={`collapseLinkedIn-${i}`}
                                  >
                                    <img
                                      src={linkedinaccordian}
                                      alt="LinkedIn"
                                      className="accordion-icon"
                                    />
                                    LinkedIn
                                  </button>
                                </h2>

                                <div
                                  id={`collapseLinkedIn-${i}`}
                                  className="accordion-collapse collapse"
                                  aria-labelledby={`headingLinkedIn-${i}`}
                                  data-bs-parent={`#accordion-week-${i + 1}`}
                                >
                                  <div className="accordion-body text-center">
                                    <div className="d-flex flex-wrap gap-3">
                                      {["Posts", "Article"].map((activity) => (
                                        <div
                                          key={activity}
                                          className="d-flex align-items-center"
                                        >
                                          <span className="me-2 text-capitalize">
                                            {activity}
                                          </span>
                                          <div className="Counter">
                                            <button
                                              className="btn btn-outline-secondary btn-sm me-2"
                                              onClick={() =>
                                                handleCountChange(
                                                  i + 1,
                                                  "LinkedIn",
                                                  activity,
                                                  false
                                                )
                                              }
                                            >
                                              -
                                            </button>
                                            <span className="me-2">
                                              {timeLine.find(
                                                (w) => w.week === i + 1
                                              )?.LinkedIn[activity] || 0}
                                            </span>
                                            <button
                                              className="btn btn-outline-secondary btn-sm"
                                              onClick={() =>
                                                handleCountChange(
                                                  i + 1,
                                                  "LinkedIn",
                                                  activity,
                                                  true
                                                )
                                              }
                                            >
                                              +
                                            </button>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                </div>
                              </div> */}
                              {/* Reddit Accordion Item */}
                              {/* <div className="accordion-item mb-3">
                                <h2
                                  className="accordion-header"
                                  id={`headingReddit-${i}`}
                                >
                                  <button
                                    className="accordion-button collapsed custom-accordion-btn"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#collapseReddit-${i}`}
                                    aria-expanded="false"
                                    aria-controls={`collapseReddit-${i}`}
                                  >
                                    <img
                                      src={redditaccordian}
                                      alt="Reddit"
                                      className="accordion-icon"
                                    />
                                    Reddit
                                  </button>
                                </h2>

                                <div
                                  id={`collapseReddit-${i}`}
                                  className="accordion-collapse collapse"
                                  aria-labelledby={`headingReddit-${i}`}
                                  data-bs-parent={`#accordion-week-${i + 1}`}
                                >
                                  <div className="accordion-body text-center">
                                    <div className="d-flex flex-wrap gap-3">
                                      {["Posts", "Comments"].map((activity) => (
                                        <div
                                          key={activity}
                                          className="d-flex align-items-center"
                                        >
                                          <span className="me-2 text-capitalize">
                                            {activity}
                                          </span>
                                          <div className="Counter">
                                            <button
                                              className="btn btn-outline-secondary btn-sm me-2"
                                              onClick={() =>
                                                handleCountChange(
                                                  i + 1,
                                                  "Reddit",
                                                  activity,
                                                  false
                                                )
                                              }
                                            >
                                              -
                                            </button>
                                            <span className="me-2">
                                              {timeLine.find(
                                                (w) => w.week === i + 1
                                              )?.Reddit[activity] || 0}
                                            </span>
                                            <button
                                              className="btn btn-outline-secondary btn-sm"
                                              onClick={() =>
                                                handleCountChange(
                                                  i + 1,
                                                  "Reddit",
                                                  activity,
                                                  true
                                                )
                                              }
                                            >
                                              +
                                            </button>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                </div>
                              </div> */}
                              {/* Quora Accordion Item */}
                              {/* <div className="accordion-item mb-3">
                                <h2
                                  className="accordion-header"
                                  id={`headingQuora-${i}`}
                                >
                                  <button
                                    className="accordion-button collapsed custom-accordion-btn"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#collapseQuora-${i}`}
                                    aria-expanded="false"
                                    aria-controls={`collapseQuora-${i}`}
                                  >
                                    <img
                                      src={quaraaccordian}
                                      alt="Quora"
                                      className="accordion-icon"
                                    />
                                    Quora
                                  </button>
                                </h2>

                                <div
                                  id={`collapseQuora-${i}`}
                                  className="accordion-collapse collapse"
                                  aria-labelledby={`headingQuora-${i}`}
                                  data-bs-parent={`#accordion-week-${i + 1}`}
                                >
                                  <div className="accordion-body text-center">
                                    <div className="d-flex flex-wrap gap-3">
                                      {["Answers", "Posts"].map((activity) => (
                                        <div
                                          key={activity}
                                          className="d-flex align-items-center"
                                        >
                                          <span className="me-2 text-capitalize">
                                            {activity}
                                          </span>
                                          <div className="Counter">
                                            <button
                                              className="btn btn-outline-secondary btn-sm me-2"
                                              onClick={() =>
                                                handleCountChange(
                                                  i + 1,
                                                  "Quora",
                                                  activity,
                                                  false
                                                )
                                              }
                                            >
                                              -
                                            </button>
                                            <span className="me-2">
                                              {timeLine.find(
                                                (w) => w.week === i + 1
                                              )?.Quora[activity] || 0}
                                            </span>
                                            <button
                                              className="btn btn-outline-secondary btn-sm"
                                              onClick={() =>
                                                handleCountChange(
                                                  i + 1,
                                                  "Quora",
                                                  activity,
                                                  true
                                                )
                                              }
                                            >
                                              +
                                            </button>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                </div>
                              </div> */}
                              {/* Twitch Accordion Item */}
                              {/* <div className="accordion-item">
                                <h2
                                  className="accordion-header"
                                  id={`headingTwitch-${i}`}
                                >
                                  <button
                                    className="accordion-button collapsed custom-accordion-btn"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#collapseTwitch-${i}`}
                                    aria-expanded="false"
                                    aria-controls={`collapseTwitch-${i}`}
                                  >
                                    <img
                                      src={twitchaccordian}
                                      alt="Twitch"
                                      className="accordion-icon"
                                    />
                                    Twitch
                                  </button>
                                </h2>

                                <div
                                  id={`collapseTwitch-${i}`}
                                  className="accordion-collapse collapse"
                                  aria-labelledby={`headingTwitch-${i}`}
                                  data-bs-parent={`#accordion-week-${i + 1}`}
                                >
                                  <div className="accordion-body text-center">
                                    <div className="d-flex flex-wrap gap-3">
                                      {["Clips", "Streams"].map((activity) => (
                                        <div
                                          key={activity}
                                          className="d-flex align-items-center"
                                        >
                                          <span className="me-2 text-capitalize">
                                            {activity}
                                          </span>
                                          <div className="Counter">
                                            <button
                                              className="btn btn-outline-secondary btn-sm me-2"
                                              onClick={() =>
                                                handleCountChange(
                                                  i + 1,
                                                  "Twitch",
                                                  activity,
                                                  false
                                                )
                                              }
                                            >
                                              -
                                            </button>
                                            <span className="me-2">
                                              {timeLine.find(
                                                (w) => w.week === i + 1
                                              )?.Twitch[activity] || 0}
                                            </span>
                                            <button
                                              className="btn btn-outline-secondary btn-sm"
                                              onClick={() =>
                                                handleCountChange(
                                                  i + 1,
                                                  "Twitch",
                                                  activity,
                                                  true
                                                )
                                              }
                                            >
                                              +
                                            </button>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                </div>
                              </div> */}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  {/* <hr className="mt-3" /> */}
                  {/* <div className="mt-4">
                {timeLine.length > 0 &&
                  timeLine.some(
                    (weekData) =>
                      Object.values(weekData.Instagram).some(
                        (val) => val > 0
                      ) ||
                      Object.values(weekData.YouTube).some((val) => val > 0)
                  ) && <h5 className="mb-3">Summary</h5>}

                {timeLine.map((weekData) => {
                  const isInstagramEmpty = Object.values(
                    weekData.Instagram
                  ).every((val) => val === 0);
                  const isYouTubeEmpty = Object.values(weekData.YouTube).every(
                    (val) => val === 0
                  );

                  if (isInstagramEmpty && isYouTubeEmpty) return null; // Skip rendering if all values are 0

                  return (
                    <div key={weekData.week} className="Summery">
                      <h6 className="card-title">Week {weekData.week}</h6>
                      <div>
                        {!isInstagramEmpty && (
                          <ul>
                            <span>Reels: {weekData.Instagram.reels}</span>,
                            <span>Posts: {weekData.Instagram.posts}</span>,
                            <span>Stories: {weekData.Instagram.story}</span>
                          </ul>
                        )}
                        {!isYouTubeEmpty && (
                          <ul>
                            <span>Shorts: {weekData?.YouTube.shorts}</span>,
                            <span>Videos: {weekData?.YouTube.videos}</span>,
                            <span>
                              Live Streams: {weekData?.YouTube.live_stream}
                            </span>
                          </ul>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div> */}
                </div>
              </div>
              {
                (!endDate && (
                  <div className="text-center mt-5">
                    <img
                      src={customCampainGif}
                      alt="Custom Campaign Loading"
                      style={{ width: "120px", height: "120px" }}
                    />
                    <p className="mt-3 text-muted">
                      Building your custom timeline
                    </p>
                  </div>
                ))}
            </div>
          )}

          {/* Step 4: Overview */}
          {currentStep === 4 && (
            <div>
              {/* Campaign Poster */}

              {/* Campaign Poster with Gradient and Product Details */}
              {CampaignFormCreate?.file && CampaignFormCreate?.file.buffer ? (
                <div className="campaign-step-card-wrapper">
                  <div
                    style={{
                      background: "#fff",
                      padding: "24px",
                      borderRadius: "12px",
                      border: "1px solid rgba(238, 238, 238, 1)",
                    }}
                  >
                    <div className="mb-4 position-relative">
                      {/* Campaign Image */}
                      <img
                        src={
                          selectedImage ||
                          URL.createObjectURL(
                            new Blob([CampaignFormCreate?.file.buffer])
                          )
                        }
                        alt="Campaign Poster"
                        className="img-fluid rounded"
                        style={{
                          maxHeight: "250px",
                          objectFit: "cover",
                          width: "100%",
                          // border: "1px solid rgba(238, 238, 238, 1)",
                        }}
                      />

                      {/* Edit & Delete Image Icons */}
                      {/* <div className="position-absolute top-0 end-0 p-2 d-flex gap-2">
                        <img
                          src={Edit}
                          alt="Edit"
                          title="Edit"
                          className="bg-white rounded-circle shadow"
                          style={{
                            width: "38px",
                            height: "38px",
                            padding: "6px",
                            cursor: "pointer",
                          }}
                          onClick={() => alert("Edit clicked")}
                        />
                        <img
                          src={Delete}
                          alt="Delete"
                          title="Delete"
                          className="bg-white rounded-circle shadow"
                          style={{
                            width: "38px",
                            height: "38px",
                            padding: "6px",
                            cursor: "pointer",
                          }}
                          onClick={() => alert("Delete clicked")}
                        />
                      </div> */}

                      {/* Optional: Keep gradient if you want just visual effect */}
                      <div
                        className="position-absolute bottom-0 start-0 w-100"
                        style={{
                          height: "80px",
                          // background:
                          // "linear-gradient(to top, rgba(0, 0, 0, 0.7), transparent)",
                          borderRadius: "0 0 8px 8px",
                        }}
                      ></div>
                    </div>

                    {/* Product Name and Launch Date - moved below image */}
                    <div className="mb-2 product-name-launch-date d-flex gap-3">
                      <h5 className="mb-1 product-name">
                        {CampaignFormCreate?.campaign_title || "Product Name"}
                      </h5>
                      <div className="text-md-end">
                        <p className="text-overview-date mb-0">
                          (
                          {startDate
                            ? new Date(startDate).toLocaleDateString("en-GB")
                            : "Start Date"}{" "}
                          -{" "}
                          {endDate
                            ? new Date(endDate).toLocaleDateString("en-GB")
                            : "End Date"}
                          )
                        </p>
                      </div>

                      {/* <p className="mb-0 text-muted">
                        {CampaignFormCreate?.launch_date || "Launch Date"}
                      </p> */}
                    </div>

                    {/* Campaign name */}
                    <div className="title-name dates d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-4">
                      {/* Product Name */}
                      <div className="mb-2 mb-md-0">
                        <h6 className="text-muted mb-1">Product Name</h6>
                        <p className="mb-0 fw-semibold">
                          {CampaignFormCreate?.product_name || "Product Name"}
                        </p>
                      </div>
                      <div className="text-md-end">
                        <p className="text-date-overview small mb-1">
                          Launch Date
                        </p>
                        <p className="mb-0 text-muted">
                          {CampaignFormCreate?.launch_date
                            ? new Date(
                                CampaignFormCreate?.launch_date
                              ).toLocaleDateString("en-GB") // DD/MM/YYYY format
                            : "Launch Date"}
                        </p>
                      </div>

                      {/* <div className="text-md-end">
                        <p className="text-date-overview small mb-1">
                          Start Date : - End Date
                        </p>
                        <p className="text-overview-date mb-0">
                          ({startDate} to {endDate})
                        </p>
                      </div> */}
                    </div>
                  </div>
                </div>
              ) : (
                <p className="text-muted">No image uploaded</p>
              )}

              {/* Campign name */}
              {/* <div className=" title-name dates d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-4">
                <div className="mb-3 mb-md-0">
                  <h2 className="text-muted fs-5 fw-medium">
                    Campaign Name :{" "}
                    <span className="campign-title-overview">
                      {CampaignFormCreate?.campaign_title}
                    </span>
                  </h2>
                </div>
                <div className="text-md-end">
                  <p className="text-date-overview small mb-1">
                    Start Date : - End Date
                  </p>
                  <p className="text-overview-date mb-0">
                    ( {startDate} to {endDate})
                  </p>
                </div>
              </div> */}
              <div className="campaign-step-card-wrapper mt-3">
                <div
                  style={{
                    background: "#fff",
                    padding: "24px",
                    borderRadius: "12px",
                    border: "1px solid rgba(238, 238, 238, 1)",
                  }}
                >
                  <h5 className="mb-3 fw-semibold Goals-objectives">Goals</h5>

                  <div className="row g-4 align-items-stretch">
                    <div className="col-md-12 d-flex">
                      <div className="d-flex flex-column w-100">
                        <p className="mb-1 primary-objects fw-semibold">
                          Primary Objective
                        </p>
                        <p className="mb-0 objectives-content">
                          {CampaignFormCreate?.campaign_primary_objective ||
                            "—"}
                        </p>
                      </div>
                    </div>

                    <div className="col-md-12 d-flex">
                      <div className="d-flex flex-column w-100">
                        <p className="mb-1 primary-objects fw-semibold">
                          Secondary Objective
                        </p>
                        <p className="mb-0 objectives-content">
                          {CampaignFormCreate?.campaign_secondary_objective ||
                            "—"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* description */}
              <div className="campaign-step-card-wrapper mt-3">
                <div
                  style={{
                    background: "#fff",
                    padding: "24px",
                    borderRadius: "12px",
                    border: "1px solid rgba(238, 238, 238, 1)",
                  }}
                >
                  <div className="campaign-description my-1">
                    <h5 className="section-title">Campaign Description</h5>

                    <div className="section">
                      <div
                        className="phase-title mt-2 mb-3"
                        dangerouslySetInnerHTML={{
                          __html: CampaignFormCreate?.description || "",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* payment compensation */}
              <div className="campaign-step-card-wrapper mt-3">
                <div
                  style={{
                    background: "#fff",
                    padding: "24px",
                    borderRadius: "12px",
                    border: "1px solid rgba(238, 238, 238, 1)",
                  }}
                >
                  <div className="payment-compensation mt-2">
                    <h5 className="section-title">Payment and Compensation</h5>
                    <ul className="mt-2">
                      <li className="d-flex flex-column mb-2">
                        <strong className="payment-overview">
                          Payment Type
                        </strong>
                        <span className="payment-type-overview">
                          {CampaignFormCreate?.compensation_type || "N/A"}
                        </span>
                      </li>
                      <li className="d-flex flex-column">
                        <strong className="payment-overview">Budget</strong>
                        <span className="budget-overview">
                          {CampaignFormCreate?.budget &&
                          !isNaN(CampaignFormCreate.budget)
                            ? new Intl.NumberFormat("en-IN", {
                                style: "currency",
                                currency: "INR",
                              }).format(CampaignFormCreate.budget)
                            : "N/A"}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Compensation Section */}
              <div className="campaign-step-card-wrapper mt-3">
                <div
                  style={{
                    background: "#fff",
                    padding: "24px",
                    borderRadius: "12px",
                    border: "1px solid rgba(238, 238, 238, 1)",
                  }}
                >
                  <div className="info-section mb-0">
                    {/* <h2 className="OverViewTitle"></h2> */}
                    <h5 className="section-title">
                      Audience Targeting Overview
                    </h5>

                    <ul className="AudienceOverView mt-3">
                      <div className="row">
                        {/* State Section in First Column */}
                        <li className="d-flex flex-column col-6">
                          <span
                            // className="green-bullet"
                            className="text-black"
                            style={{
                              fontWeight: "600",
                              fontSize: "16px",
                              marginRight: "10px",
                            }}
                          >
                            State
                          </span>

                          <div
                            className="chipdesign mt-2"
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "8px",
                            }}
                          >
                            {selectedState.length === 0 ? (
                              "None"
                            ) : selectedState.length <= 3 ? (
                              selectedState.map((state) => {
                                const stateName = statesData.find(
                                  (s) => s.iso2 === state
                                )?.state;
                                return (
                                  <Tooltip
                                    title={stateName || state}
                                    arrow
                                    key={state}
                                  >
                                    <Chip
                                      label={stateName || state}
                                      sx={{
                                        fontSize: "14px",
                                        fontWeight: "400",
                                        backgroundColor:
                                          " rgba(221, 225, 230, 0.4)",
                                        color: "rgba(72, 72, 72, 1)",
                                        borderRadius: "20px",
                                        padding: "4px 12px",
                                        fontFamily: "Poppins, sans-serif",
                                      }}
                                    />
                                  </Tooltip>
                                );
                              })
                            ) : (
                              <>
                                {selectedState.slice(0, 3).map((state) => {
                                  const stateName = statesData.find(
                                    (s) => s.iso2 === state
                                  )?.state;
                                  return (
                                    <Tooltip
                                      title={stateName || state}
                                      arrow
                                      key={state}
                                    >
                                      <Chip
                                        label={stateName || state}
                                        sx={{
                                          fontSize: "14px",
                                          fontWeight: "400",

                                          backgroundColor:
                                            " rgba(221, 225, 230, 0.4)",
                                          color: "rgba(72, 72, 72, 1)",
                                          borderRadius: "20px",
                                          padding: "4px 12px",
                                          fontFamily: "Poppins, sans-serif",
                                        }}
                                      />
                                    </Tooltip>
                                  );
                                })}

                                <Tooltip
                                  title={selectedState
                                    .slice(3)
                                    .map((state) => {
                                      const stateName = statesData.find(
                                        (s) => s.iso2 === state
                                      )?.state;
                                      return stateName || state;
                                    })
                                    .join(", ")}
                                  arrow
                                >
                                  <Chip
                                    label={`+${selectedState.length - 3}`}
                                    sx={{
                                      fontSize: "14px",
                                      backgroundColor: "#D6E2D4",
                                      color: "#3E6259",
                                      borderRadius: "50%",
                                      width: "32px",
                                      height: "32px",
                                      textAlign: "center",

                                      fontFamily: "Poppins, sans-serif",
                                    }}
                                  />
                                </Tooltip>
                              </>
                            )}
                          </div>
                        </li>

                        {/* City Section in Second Column */}
                        <li className="d-flex flex-column col-6">
                          <span
                            // className="green-bullet"
                            className="text-black"
                            style={{
                              fontWeight: "600",
                              fontSize: "16px",
                              marginRight: "10px",
                            }}
                          >
                            City
                          </span>

                          <div
                            className="chipdesign mt-2"
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "8px",
                            }}
                          >
                            {selectedCity.length === 0 ? (
                              "None"
                            ) : selectedCity.length <= 3 ? (
                              selectedCity.map((city) => {
                                return (
                                  <Tooltip
                                    title={
                                      city === "panIndia" ? "PanIndia" : city
                                    }
                                    arrow
                                    key={city}
                                  >
                                    <Chip
                                      label={
                                        city === "panIndia" ? "PanIndia" : city
                                      }
                                      sx={{
                                        fontSize: "14px",
                                        backgroundColor: "#E5E8EC",
                                        color: "#333",
                                        borderRadius: "20px",
                                        padding: "4px 12px",
                                        fontFamily: "Poppins, sans-serif",
                                      }}
                                    />
                                  </Tooltip>
                                );
                              })
                            ) : (
                              <>
                                {/* Show first 9 cities */}
                                {selectedCity.slice(0, 3).map((city) => {
                                  return (
                                    <Tooltip
                                      title={
                                        city === "panIndia" ? "PanIndia" : city
                                      }
                                      arrow
                                      key={city}
                                    >
                                      <Chip
                                        label={
                                          city === "panIndia"
                                            ? "PanIndia"
                                            : city
                                        }
                                        sx={{
                                          fontSize: "14px",
                                          fontWeight: "400",

                                          backgroundColor:
                                            " rgba(221, 225, 230, 0.4)",
                                          color: "rgba(72, 72, 72, 1)",
                                          borderRadius: "20px",
                                          padding: "4px 12px",
                                          fontFamily: "Poppins, sans-serif",
                                        }}
                                      />
                                    </Tooltip>
                                  );
                                })}

                                {/* Chip that shows the count of remaining cities */}
                                <Tooltip
                                  title={selectedCity
                                    .slice(3)
                                    .map((city) =>
                                      city === "panIndia" ? "PanIndia" : city
                                    )
                                    .join(", ")} // Show the additional cities when hovered
                                  arrow
                                >
                                  <Chip
                                    label={`+${selectedCity.length - 3}`} // Show the count of extra cities
                                    sx={{
                                      fontSize: "14px",
                                      backgroundColor: "#D6E2D4",
                                      color: "#3E6259",
                                      borderRadius: "50%",
                                      width: "32px",
                                      height: "32px",
                                      textAlign: "center",
                                      fontFamily: "Poppins, sans-serif",
                                    }}
                                  />
                                </Tooltip>
                              </>
                            )}
                          </div>
                        </li>
                      </div>

                      <div className="row">
                        {/* Gender Section in First Column */}
                        <li className="d-flex flex-column col-6">
                          <span
                            // className="green-bullet"
                            className="text-black"
                            style={{
                              fontWeight: "600",
                              fontSize: "16px",
                              marginRight: "10px",
                            }}
                          >
                            Gender
                          </span>

                          <div
                            className="chipdesign mt-2"
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "8px",
                            }}
                          >
                            {!CampaignFormCreate?.gender ||
                            CampaignFormCreate.gender.length === 0 ? (
                              "None"
                            ) : (
                              <>
                                {/* Display first 3 gender chips */}
                                {CampaignFormCreate.gender
                                  .slice(0, 3)
                                  .map((gender) => (
                                    <Tooltip title={gender} arrow key={gender}>
                                      <Chip
                                        label={gender}
                                        sx={{
                                          fontSize: "14px",
                                          fontWeight: "400",
                                          backgroundColor:
                                            "rgba(221, 225, 230, 0.4)",
                                          color: "rgba(72, 72, 72, 1)",
                                          borderRadius: "20px",
                                          padding: "4px 12px",
                                          fontFamily: "Poppins, sans-serif",
                                        }}
                                      />
                                    </Tooltip>
                                  ))}

                                {/* Show count chip for remaining genders */}
                                {CampaignFormCreate.gender.length > 3 && (
                                  <Tooltip
                                    title={CampaignFormCreate.gender
                                      .slice(3)
                                      .join(", ")} // Tooltip shows extras
                                    arrow
                                  >
                                    <Chip
                                      label={`+${
                                        CampaignFormCreate.gender.length - 3
                                      }`}
                                      sx={{
                                        fontSize: "14px",
                                        backgroundColor: "#D6E2D4",
                                        color: "#3E6259",
                                        borderRadius: "50%",
                                        width: "32px",
                                        height: "32px",
                                        textAlign: "center",
                                        fontFamily: "Poppins, sans-serif",
                                      }}
                                    />
                                  </Tooltip>
                                )}
                              </>
                            )}
                          </div>
                        </li>

                        {/* Language Section in Second Column */}
                        <li className="d-flex flex-column col-6">
                          <span
                            // className="green-bullet"
                            className="text-black"
                            style={{
                              fontWeight: "600",
                              fontSize: "16px",
                              marginRight: "10px",
                            }}
                          >
                            Language
                          </span>

                          <div
                            className="chipdesign mt-2"
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "8px",
                            }}
                          >
                            {selectedLangNames.length === 0 ? (
                              "None"
                            ) : (
                              <>
                                {/* Display first 3 language chips */}
                                {selectedLangNames.slice(0, 3).map((name) => (
                                  <Tooltip title={name} arrow key={name}>
                                    <Chip
                                      label={name}
                                      sx={{
                                        fontSize: "14px",
                                        fontWeight: "400",

                                        backgroundColor:
                                          " rgba(221, 225, 230, 0.4)",
                                        color: "rgba(72, 72, 72, 1)",
                                        borderRadius: "20px",
                                        padding: "4px 12px",
                                        fontFamily: "Poppins, sans-serif",
                                      }}
                                    />
                                  </Tooltip>
                                ))}

                                {/* Show count chip for remaining languages */}
                                {selectedLangNames.length > 3 && (
                                  <Tooltip
                                    title={selectedLangNames
                                      .slice(3)
                                      .join(", ")} // Show remaining languages in tooltip
                                    arrow
                                  >
                                    <Chip
                                      label={`+${selectedLangNames.length - 3}`} // Count of extra languages
                                      sx={{
                                        fontSize: "14px",
                                        backgroundColor: "#D6E2D4",
                                        color: "#3E6259",
                                        borderRadius: "50%",
                                        width: "32px",
                                        height: "32px",
                                        textAlign: "center",
                                        fontFamily: "Poppins, sans-serif",
                                      }}
                                    />
                                  </Tooltip>
                                )}
                              </>
                            )}
                          </div>
                        </li>
                      </div>

                      <li className="d-flex flex-column">
                        <span
                          // className="green-bullet"
                          className="text-black"
                          style={{
                            fontWeight: "600",
                            fontSize: "16px",
                            marginRight: "10px",
                          }}
                        >
                          Age Group
                        </span>

                        <div
                          className="chipdesignage mt-2"
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "8px",
                          }}
                        >
                          {selectedAge.length === 0 ? (
                            "None"
                          ) : selectedAge.length <= 9 ? (
                            <>
                              {/* Display all selected age groups as chips if there are 9 or fewer */}
                              {selectedAge.map((age) => (
                                <Tooltip title={age} arrow key={age}>
                                  <Chip
                                    label={age}
                                    sx={{
                                      fontSize: "14px",
                                      fontWeight: "400",

                                      backgroundColor:
                                        " rgba(221, 225, 230, 0.4)",
                                      color: "rgba(72, 72, 72, 1)",
                                      borderRadius: "20px",
                                      padding: "4px 12px",
                                      fontFamily: "Poppins, sans-serif",
                                    }}
                                  />
                                </Tooltip>
                              ))}
                            </>
                          ) : (
                            <>
                              {/* Display first 9 age groups as chips */}
                              {selectedAge.slice(0, 9).map((age) => (
                                <Tooltip title={age} arrow key={age}>
                                  <Chip
                                    label={age}
                                    sx={{
                                      fontSize: "14px",
                                      backgroundColor: "#E5E8EC",
                                      color: "#333",
                                      borderRadius: "20px",
                                      padding: "4px 12px",
                                      fontFamily: "Poppins, sans-serif",
                                    }}
                                  />
                                </Tooltip>
                              ))}

                              {/* If there are more than 9 age groups, show a count chip */}
                              <Tooltip
                                title={selectedAge.slice(9).join(", ")} // Show remaining age groups in tooltip
                                arrow
                              >
                                <Chip
                                  label={`+${selectedAge.length - 9}`} // Show the count of extra age groups
                                  sx={{
                                    fontSize: "14px",
                                    backgroundColor: "#D6E2D4",
                                    color: "#3E6259",
                                    borderRadius: "50%",
                                    width: "32px",
                                    height: "32px",
                                    textAlign: "center",
                                    fontFamily: "Poppins, sans-serif",
                                  }}
                                />
                              </Tooltip>
                            </>
                          )}
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Overview content goes here */}

              <div className="secret-santa p-2">
                <div className="campaign-step-card-wrapper mt-3">
                  <div
                    style={{
                      background: "#fff",
                      padding: "24px",
                      borderRadius: "12px",
                      border: "1px solid rgba(238, 238, 238, 1)",
                    }}
                  >
                    <h5 className="section-title">Campaign Deliverables</h5>

                    {timeLine.length > 0 && (
                      <div className="container mt-4">
                        {/* <h5 className="fw-semibold mb-3">Campaign Deliverables</h5> */}
                        <div className="table-responsive">
                          <table className="table table-bordered text-center align-middle deliverable-table">
                            <thead className="table-light">
                              <tr>
                                <th
                                  rowSpan={2}
                                  style={{ verticalAlign: "middle" }}
                                >
                                  Tools
                                </th>
                                <th
                                  rowSpan={2}
                                  style={{ verticalAlign: "middle" }}
                                >
                                  Deliverables
                                </th>
                                {timeLine.map((week, i) => (
                                  <th key={i}>Week{i + 1}</th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {Object.entries(timeLine[0]).map(
                                ([platform, deliverables], platformIndex) => (
                                  <>
                                    {Object.keys(deliverables).map(
                                      (deliverable, i) => (
                                        <tr key={`${platform}-${deliverable}`}>
                                          {i === 0 && (
                                            <td
                                              rowSpan={
                                                Object.keys(deliverables).length
                                              }
                                              className="fw-semibold"
                                            >
                                              {platform}
                                            </td>
                                          )}
                                          <td>
                                            {formatDeliverableName(deliverable)}
                                          </td>
                                          {timeLine.map((week, wIdx) => (
                                            <td key={wIdx}>
                                              {week[platform]?.[deliverable] > 0
                                                ? week[platform][deliverable]
                                                : 0}
                                            </td>
                                          ))}
                                        </tr>
                                      )
                                    )}
                                  </>
                                )
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Auto-publish Section */}
                <div className="publish-section">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="autoPublish"
                    />
                    <label className="form-check-label" htmlFor="autoPublish">
                      Automatically Publish on Schedule Date
                    </label>
                  </div>
                  <div className="button-group"></div>
                </div>
              </div>
            </div>
          )}

          {/* Navigation Buttons */}
          <div className="navigation-buttons d-flex align-items-end mt-4 justify-content-between">
            {/* Back Button on Left */}
            <div>
              {currentStep > 1 && (
                <button className="button-back" onClick={handlePrevbtn}>
                  &lt; Back
                </button>
              )}
            </div>

            {/* Step Navigation Buttons on Right */}
            <div>
              {/* Save as Draft - always visible */}
              <button
                className="save-draft-button me-2"
                onClick={() => openModal("draft")}
              >
                Save As Draft
              </button>

              {currentStep === totalSteps ? (
                // Last step - show Publish button
                <button
                  className="next-button btn btn-primary"
                  onClick={() => openModal("publish")}
                  style={{ backgroundColor: "rgba(107, 142, 118, 1)" }}
                >
                  Publish
                </button>
              ) : (
                // Other steps - show Save & Next button
                <button
                  className="next-button btn btn-primary"
                  onClick={handleNextbtn}
                  style={{ backgroundColor: "rgba(107, 142, 118, 1)" }}
                >
                  Save & Next
                </button>
              )}
            </div>

            {/* Confirmation Modal */}
            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
              <Modal.Body
                className="custom-modal"
                style={{
                  color: "rgb(82 82 82)",
                  fontWeight: "500",
                  textAlign: "center",
                }}
              >
                {modalType === "publish"
                  ? "Are you sure you want to publish this campaign?"
                  : "Are you sure you want to save this campaign as a draft?"}
              </Modal.Body>
              <Modal.Footer
                className="d-flex justify-content-center custom-modal"
                style={{ borderTop: "none" }}
              >
                <Button variant="secondary" onClick={() => setShowModal(false)}>
                  No
                </Button>
                <Button
                  onClick={handleConfirm}
                  className="publish-btn"
                  style={{ backgroundColor: "#668770" }}
                >
                  Yes
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
}
